import Vue from 'vue';

const success = (context, response) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal(context.$t('booking.detail.reservation_cancelled_due_card'), '', 'success');
};

const failed = (context, error) => {
  swal("Error", error.response.data.msg, "error");
};

export default (context, bookingId) => {
  return Vue.$http.post('bookings/report-cancel-invalid-card', {bookingId})
    .then(response => {
      if (response && response.status === 200) {
        success(context, response.data);
      }
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/booking/cancelReportInvalidCard.js